import React, { ReactElement } from 'react';
import { Skeleton, Row, Col, Card } from 'antd';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';

const ColumnLoader = ({ col }: any): ReactElement => {
  const cardItem = [
    [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }], [{ id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }],
  ];
  return (
    <div className={!col ? 'ant-tabs-content-holder' : ''}>
      <Row gutter={GUTTOR_SPACE} >
        {cardItem.map((column: any, index: any): any =>
          <>
           {column.map((item: any): any =>
            <Col key={item.id} md={col || 8} style={{ marginTop: '30px' }}>
              <Card>
                <div className="document-card" style={{width: 250}}>
                  <Skeleton active={true} paragraph={{ rows: 2 }} />
                </div>
                </Card>
              </Col>,
            )}
          </>,
        )}
      </Row>,
    </div>
  );
};

export default ColumnLoader;
